module.exports = __webpack_public_path__ + "img/logo.2a4749e4.png";